import { render, staticRenderFns } from "./cube-ui-swipe-item.vue?vue&type=template&id=532ef0f2"
import script from "./cube-ui-swipe-item.vue?vue&type=script&lang=js"
export * from "./cube-ui-swipe-item.vue?vue&type=script&lang=js"
import style0 from "./cube-ui-swipe-item.vue?vue&type=style&index=0&id=532ef0f2&prod&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports